<template>
  <div class="side">
    <!-- 顶部统计块 -->

    <div class="container">
      <div class="status-cards">
        <div class="card">
          <div class="status-header">
            <div class="status-indicator warning"></div>
            <div class="status-title" @click="toInfo('drivers')">塔司数</div>
          </div>
          <div class="server-count">{{ driverCount }}</div>
        </div>
        <div class="card">
          <div class="status-header">
            <div class="status-indicator offline"></div>
            <div class="status-title">劳务队数</div>
          </div>
          <div class="server-count" @click="toInfo('workerRating')">
            {{ teamCount }}
          </div>
        </div>
        <div class="card">
          <div class="status-header">
            <div class="status-indicator online"></div>
            <div class="status-title">设备在线</div>
          </div>
          <div class="server-count" @click="toInfo('ieDevice')">
            {{ onlineCount }}
          </div>
        </div>
        <div class="card">
          <div class="status-header">
            <div class="status-indicator totalcount"></div>
            <div class="status-title">设备总数</div>
          </div>
          <div class="server-count" @click="toInfo('ieDevice')">
            {{ totalCount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { listScore } from '@/api/iemanage/scoreStatistics'
// import { getDriverCount } from '@/api/iemanage/drivers_screen'
// import { getIeDeviceCount } from '@/api/iemanage/drivers_index'

export default {
  name: 'LeftPanel',
  // components: {
  //   ChartsColumn: () => import('../charts_drivers/ChartsColumn.vue'),
  //   ChartsPie: () => import('../charts_drivers/ChartsPie.vue'),
  //   StackedColumn: () => import('../charts_drivers/StackedColumn.vue')
  // },

  data() {
    return {
      projectId: null,
      dataInterval: null,
      driverCount: 0,
      teamCount: 0,
      onlineCount: 0,
      totalCount: 0,
      paused: false,

      driverRatingData: [], //驾驶员评分数据
      workerRatingData: [], //劳务队评分数据
      projectRatingData: [], //项目评分数据
      behaviorList: [],
      worktimeoutList: [],
      pickerDate: [],
      workPickerDate: [],
      queryParams: {
        pageNum: 1,
        pageSize: 20
      },
      queryWorkParams: {
        pageNum: 1,
        pageSize: 20
      },

      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  mounted() {
    // // 轮询
    // this.getDriverCountFn()
    // this.getIeDeviceCount() // 初始化加载一次
    // this.dataInterval = setInterval(() => {
    //   this.getDriverCountFn()
    //   this.getIeDeviceCount()
    // }, 30 * 60 * 1000)
  },
  beforeDestroy() {
    // clearInterval(this.dataInterval)
  },
  methods: {
    // 驾驶员数量。劳务队数量
    // getDriverCountFn() {
    //   getDriverCount({}).then((res) => {
    //     if (res.code == 200) {
    //       this.driverCount = res.data['驾驶员'] || 0
    //       this.teamCount = res.data['劳务队'] || 0
    //     }
    //   })
    // },

    // getIeDeviceCount() {
    //   getIeDeviceCount({}).then((res) => {
    //     this.totalCount = res.data.deviceCount
    //     this.onlineCount = res.data.onlineCount
    //     // this.useCount = res.data.useCount
    //     // this.powerOn = res.data.powerOn
    //   })
    // },
    /** 项目评分 */
    // projectRating() {
    //   let params = {
    //     pageNum: 1,
    //     pageSize: -1,
    //     type: '1',
    //     beginTime: this.beginTime,
    //     endTime: this.endTime
    //   }

    //   return new Promise((resolve) => {
    //     listScore(params).then((response) => {
    //       this.projectRatingData = response.data.records.map((item) => {
    //         return {
    //           label: item.name,
    //           value: item.aveScore
    //         }
    //       })
    //       console.log(this.projectRatingData, '项目评分')
    //     })

    //     resolve()
    //   })
    // },
    // /** 劳务队评分 */
    // workerRating() {
    //   let params = {
    //     projectId: null,
    //     deviceId: null,
    //     pageNum: 1,
    //     pageSize: -1,
    //     type: '2',
    //     beginTime: this.beginTime,
    //     endTime: this.endTime
    //   }

    //   return new Promise((resolve) => {
    //     listScore(params).then((response) => {
    //       this.workerRatingData = response.data.records.map((item) => {
    //         return {
    //           label: item.name || '',
    //           value: item.aveScore
    //         }
    //       })
    //       console.log(response.data.records, '劳务队评分')
    //     })

    //     resolve()
    //   })
    // },
    resize() {},
    /** 图表去详情 */
    toInfo(el, item) {
      console.log(el, item, '图表去详情')
      if (el == 'ieDevice') {
        //(智能终端设备)
        this.$router.push('/manage/iemanage/smart-device')
      } else if (el == 'drivers') {
        //(塔司管理)
        this.$router.push('/manage/iemanage/drivers-page')
      } else if (el == 'driverRating') {
        //（驾驶员评分） 带参数
        this.$router.push({
          path:
            '/manage/iemanage/score-statistics-drivers?projectId=' +
            this.projectId
        })
      } else if (el == 'workerRating') {
        //（劳务队评分） 带参数
        this.$router.push({
          path:
            '/manage/iemanage/score-statistics?type=2&projectId=' +
            this.projectId
          // path: '/manage/iemanage/acount-team?projectId=' + this.projectId
        })
      } else if (el == 'driverWorking') {
        //（驾驶员工时） 带参数
        this.$router.push({
          path: '/manage/iemanage/clock?projectId=' + this.projectId
        })
      } else if (el == 'projectRating') {
        // 项目评分
        // this.$router.push(`/manage/iemanage/acount-project`)
        this.$router.push({
          path:
            '/manage/iemanage/score-statistics?type=1&projectId=' +
            this.projectId
        })
      } else if (el == 'projectWorking') {
        // 项目工时
        this.$router.push(`/manage/iemanage/work-project`)
      }
      // 劳务队带项目参数
      else if (el == 'workerAge') {
        this.$router.push({
          path: '/manage/iemanage/age-team?projectId=' + this.projectId
        })
      } else if (el == 'workerCard') {
        this.$router.push({
          path: '/manage/iemanage/card-team?projectId=' + this.projectId
        })
      } else if (el == 'workerSex') {
        this.$router.push({
          path: '/manage/iemanage/sex-team?projectId=' + this.projectId
        })
      } else if (el == 'projectAge') {
        this.$router.push(`/manage/iemanage/age-project`)
      } else if (el == 'projectCard') {
        this.$router.push(`/manage/iemanage/card-project`)
      } else if (el == 'projectSex') {
        this.$router.push(`/manage/iemanage/sex-project`)
      } else if (el == 'clock') {
        // 打卡详情
        this.$router.push(
          `/manage/iemanageclock/clock-info?driverId=` + item.driverId
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  // max-width: 1200px;
  // text-align: center;
  display: flex;
  flex-direction: column;
}

.status-cards {
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 25px;
}

.card {
  // background: rgba(255, 255, 255, 0.95);
  // border-radius: 16px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 10px;
  // width: 300px;
  transition: all 0.3s ease;
  // backdrop-filter: blur(10px);
  // border: 1px solid rgba(255, 255, 255, 0.2);
}

.card:hover {
  transform: translateY(-5px);
  // box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.status-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.online {
  background: linear-gradient(135deg, #00b09b, #96c93d);
  box-shadow: 0 0 10px rgba(0, 176, 155, 0.5);
}

.offline {
  background: linear-gradient(135deg, #8e0e00, #1f1c18);
}

.warning {
  background: linear-gradient(135deg, #ff8c00, #ffcc00);
}
.totalcount {
  background: linear-gradient(135deg, #3498db, #2980b9);
}
.status-title {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.server-count {
  cursor: pointer;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
}
.server-count:hover {
  color: #005eb8;
}
.server-label {
  color: #7f8c8d;
  font-size: 1rem;
  margin-bottom: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
}

.btn-secondary {
  background: #ecf0f1;
  color: #7f8c8d;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.chart-container {
  height: 100px;
  margin: 20px 0;
}
</style>
